import { apiRequest } from './httpClient';

export const getMyTeamProfile = () => apiRequest('getMyTeamProfile', { method: 'GET' });

export const saveMyTeamProfile = (profile) => apiRequest('saveMyTeamProfile', {
  method: 'POST',
  body: { profile },
});
